import { toastService } from "../../../component/common/toast-messages/toast";
import Actions from "../../actions";
import * as requestFromServer from "./customersApis";

// get all customers -> api
export const getCustomersAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.getCustomers(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_CUSTOMERS_LIST, {customers:response}));
      return response;
    }
};

// get customers -> get customer info by id api
export const getCustomerInfoByIdAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getCustomerInfoById(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    }
    else {
      setLoading(false);
      return null;
    }
};


// update customer status -> update customer status api
export const updateCustomerStatusAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.updateCustomerStatus(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    }
    else {
      setLoading(false);
      return null;
    }
};